// /help/:collectionSlug — one topic's articles.
import React from 'react';
import { Helmet } from 'react-helmet';
import { Link, Navigate, useParams } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import AppTransition from '../components/appComponents/AppTransition';
import { collectionBySlug, getArticlesForCollection } from './helpUtils';
import { ArticleList, ContactCard, topicIcon } from './helpParts';
import './helpCenter.css';

const HelpCollection = () => {
  const { collectionSlug } = useParams();
  const collection = collectionBySlug[collectionSlug];
  if (!collection) return <Navigate to="/help" replace />;
  const articles = getArticlesForCollection(collection.slug);

  return (
    <AppTransition key={collection.slug}>
      <div className="help-page">
        <Helmet><title>{`Bumpups | ${collection.title}`}</title></Helmet>
        <nav className="help-crumbs" aria-label="Breadcrumb">
          <Link to="/help">Help</Link>
          <span aria-hidden="true">/</span>
          <span>{collection.title}</span>
        </nav>

        <div className="help-topic-head">
          <span className="help-topic-icon help-topic-icon--lg"><FontAwesomeIcon icon={topicIcon(collection.slug)} /></span>
          <div>
            <h1 className="help-title">{collection.title}</h1>
            <p className="help-subtitle">{collection.description} · {articles.length} articles</p>
          </div>
        </div>

        <section className="help-section">
          <ArticleList articles={articles} />
        </section>

        <ContactCard />
      </div>
    </AppTransition>
  );
};

export default HelpCollection;
